import './SectionComplexView.css';
export default {
    "wrapper": "SectionComplexView_wrapper__1ynz2",
    "title": "SectionComplexView_title__1ynz2",
    "content": "SectionComplexView_content__1ynz2"
};
